import { Alert } from '@design-system/components/alert/alert';
import { Button } from '@design-system/components/button/button';
import { ExternalLink } from '@design-system/components/link/externalLink';
import { Radio, RadioGroup } from '@design-system/components/radio/radio';
import { Typography } from '@design-system/components/typography/typography';
import {
  LandingPageThemeId,
  landingPageThemes,
} from '@client/new/common/landingPageThemes';
import { themeOrDefault } from './pageLook';
import * as styles from './PageLookCard.css';

type PageLookCardProps = {
  mode: 'offer-switch' | 'pick-theme';
  selectedTheme: LandingPageThemeId;
  onSelectTheme: (theme: LandingPageThemeId) => void;
  previewUrl: string | null;
  onOpenSwitch: () => void;
  justSwitched: boolean;
  isStaff: boolean;
};

export const PageLookCard = ({
  mode,
  selectedTheme,
  onSelectTheme,
  previewUrl,
  onOpenSwitch,
  justSwitched,
  isStaff,
}: PageLookCardProps) => (
  <div className={styles.content}>
    {justSwitched ? (
      <Alert
        variant="success"
        title={
          isStaff
            ? 'These pages now use the new look'
            : 'Your pages now use the new look'
        }
        allowClose
      />
    ) : null}
    <div className={styles.intro}>
      {mode === 'offer-switch' ? (
        <>
          <Typography variant="body" size="large" fontWeight="normal">
            A new look is ready for your landing pages. It applies to all of
            them, your channel, programs and offers.
          </Typography>
          <Typography variant="body" size="medium" fontWeight="normal">
            Pick a theme. Your colour still comes from Your brand below.
          </Typography>
        </>
      ) : (
        <Typography variant="body" size="large" fontWeight="normal">
          Pick the theme for all your landing pages, then Save. Your colour
          still comes from Your brand below.
        </Typography>
      )}
    </div>
    <RadioGroup
      value={selectedTheme}
      onChange={(value) => onSelectTheme(themeOrDefault(value))}
      ariaLabel="Theme"
      className={styles.themes}
    >
      {landingPageThemes.map((theme) => (
        <Radio
          key={theme.id}
          value={theme.id}
          label={theme.name}
          hint={theme.descriptor}
          testId={`page-look-theme-${theme.id}`}
        />
      ))}
    </RadioGroup>
    <div className={styles.actions}>
      {mode === 'offer-switch' ? (
        <Button color="neutral" onClick={onOpenSwitch}>
          Switch to the new look
        </Button>
      ) : null}
      {previewUrl ? (
        <ExternalLink
          href={previewUrl}
          label="Preview this theme"
          textSize="large"
        />
      ) : null}
    </div>
  </div>
);
